import { useState } from 'react';

import { TripAssignModal } from './TripAssignModal';
import { PrimaryButton } from '../../../components/button/PrimaryButton';
import { t } from '../../../services/translation/translation';

type Props = {
  tripKey: string;
};

export const TripAssignButton = ({ tripKey }: Props) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <>
      <PrimaryButton text={t('common.assign')} onClick={() => setIsModalVisible(true)} />
      {isModalVisible ? <TripAssignModal onClose={() => setIsModalVisible(false)} tripKey={tripKey} /> : null}
    </>
  );
};
